import React, { Component } from 'react';

import { currencyFormatter } from '../../utilities/currencyFormatter';

import {
  DataTypeProvider,
  IntegratedSorting,
  SortingState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  TableColumnResizing,
  TableHeaderRow,
  VirtualTable,
} from '@devexpress/dx-react-grid-material-ui';

const CurrencyTypeProvider = (props) => (
  <DataTypeProvider
    formatterComponent={currencyFormatter}
    {...props}
  />
);

class ChartDetailGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: 'program', title: 'Program' },
        { name: 'currentYear', title: 'This Year' },
        { name: 'previousYear', title: 'Last Year' },
      ],
      columnWidths: [
        { columnName: 'program', width: 230 },
        { columnName: 'currentYear', width: 88 },
        { columnName: 'previousYear', width: 88 },
      ],
      rows: [],
      currencyColumns: ['currentYear', 'previousYear'],
      sorting: [{ columnName: 'currentYear', direction: 'desc' }],
    };

    this.changeSorting = (sorting) => this.setState({ sorting });

    this.TableRow = ({ row, ...restProps }) => {
      return (<VirtualTable.Row
        {...restProps}
        style={{
          cursor: 'default',
        }}
              />);
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ rows: nextProps.rows });
  }

  componentWillMount() {
    this.setState({ rows: this.props.rows });
  }

  render() {
    const { rows, columns, sorting, columnWidths, currencyColumns } = this.state;

    if (!rows) {
      return <div />;
    }

    return (
      <Grid rows={rows} columns={columns}>
        <CurrencyTypeProvider
          for={currencyColumns}
        />
        <SortingState
          sorting={sorting}
          onSortingChange={this.changeSorting}
        />
        <IntegratedSorting />
        <VirtualTable rowComponent={this.TableRow} height={300} />
        <TableColumnResizing
          columnWidths={columnWidths}
        // onColumnWidthsChange={this.changeColumnWidths}
        />
        <TableHeaderRow showSortingControls />
      </Grid>
    );
  }
}

export default ChartDetailGrid;